import React from "react";
import { FooterBlockProps } from "./FooterBlock.types";

export const FooterBlock: React.FC<FooterBlockProps> = ({ title, children }: FooterBlockProps) => (
  <div className="m-footer-block">
    <h3 className="m-footer-block__title u-heading-xxsmall u-ragoon">{title}</h3>
    {children}
  </div>
);
